import { axiosIntance } from "./config";


export const getAllFranchise = async () => {
  const response = await axiosIntance.get('/franchises');
  return response.data;
};

export const getFranchise = async (id) => {
  const response = await axiosIntance.get(`/franchises/${id}`);
  return response.data;
};

export const createFranchise  = async (data) => {
  const response = await axiosIntance.post('/franchises', data);
  return response.data;
};

export const updateFranchise = async (id, payload) => {
  const response = await axiosIntance.put(`/franchises/${id}/status`, payload);
  return response.data;
};

export const deleteFranchise  = async (id) => {
  const response = await axiosIntance.delete(`/franchises/${id}`);
  return response.data;
};


export const assignToEmployees  = async (id,data) => {
  const response = await axiosIntance.post(`/franchises/${id}/assign`,data);
  return response.data;
};